<template>
  <v-theme-provider :dark="dark">
    <div>
      <base-info-card title="KEEP IN TOUCH WITH US" pace="6">
        We value your feedback dearly. Feel free to let us know how we are
        doing.
      </base-info-card>

      <!-- <Feedback
        title="Enjoying Strapp?"
        subtitle="How would you rate our service?"
      /> -->

      <base-business-contact dense />
    </div>
  </v-theme-provider>
</template>

<script>
import Feedback from '../../components/Feedback'
export default {
  name: 'BaseBusinessInfo',

  components: {
    Feedback: () => import('../../components/Feedback')
  },

  props: { dark: Boolean },

  data: () => ({
    business: [
      {
        icon: 'mdi-map-marker-outline',
        title: 'Address',
        text: '8553 N. Beach St. Ste. 227<br>Fort Worth, Texas 76137'
      },
      {
        icon: 'mdi-cellphone',
        title: 'Phone',
        text: '01 (800) 433 744<br>01 (800) 433 633'
      },
      {
        icon: 'mdi-email',
        title: 'Email',
        text: 'john@vuetifyjs.com<br>heather@vuetifyjs.com'
      }
    ]
  })
}
</script>
